import React from "react";
import Work from "../Components/Work";
import { personalDetails, workDetails, eduDetails, certDetails } from "../Details";

const SectionTitle = ({ children }) => (
  <h1 className="text-gradient text-2xl md:text-3xl xl:text-4xl font-bold mb-2">
    {children}
  </h1>
);

function About() {
  return (
    <main className="max-width pt-10 pb-20">
      <section>
        <SectionTitle>About</SectionTitle>
        <p className="text-content py-6 leading-relaxed font-medium">{personalDetails.about}</p>
      </section>
      <section className="mt-10">
        <SectionTitle>Work Experience</SectionTitle>
        {React.Children.toArray(
          workDetails.map(({ Position, Company, Location, Type, Duration }) => (
            <Work position={Position} company={Company} location={Location} type={Type} duration={Duration} />
          ))
        )}
      </section>
      <section className="mt-10">
        <SectionTitle>Education</SectionTitle>
        {React.Children.toArray(
          eduDetails.map(({ Position, Company, Location, Type, Duration }) => (
            <Work position={Position} company={Company} location={Location} type={Type} duration={Duration} />
          ))
        )}
      </section>
      <section className="mt-10">
        <SectionTitle>Certifications</SectionTitle>
        <ul className="text-content pt-4 space-y-2">
          {certDetails.map(({ name }, index) => (
            <li key={index} className="flex items-center gap-2 font-medium">
              <span className="text-sky-500 font-bold">—</span> {name}
            </li>
          ))}
        </ul>
      </section>
    </main>
  );
}

export default About;
